// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import {Organization} from './Organization';
import {SurveySection} from './SurveySection';
import {SurveyProgram} from './SurveyProgram';
import {SurveyType} from './SurveyType';

const _associations = [
			{
				name: 'Organization',
				model: new Organization(),
				type: 'ParentPointer',
				using: 'organizationId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: true,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'Organization',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'SurveySections',
				model: new SurveySection(),
				type: 'ArrayOfChildren',
				using: 'surveyId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: null,
				group: 'Sections',
				groupTitle: 'Sections',
				displayOrder: 99,
				itemTitle: 'Survey Section',
				orderable: 'order',
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'SurveyPrograms',
				model: new SurveyProgram(),
				type: 'ArrayOfChildren',
				using: 'surveyId',
				isHidden: {
					query: 'organizationId == null',
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: 'When set, this Survey is only visible in Conservation Actions under the specified Programs. Within these Programs it will override other Surveys for the same (Survey Type + Conservation Action Type) pair. If empty this Survey will be a default for all Programs.',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: 'Program Specific Survey',
				groupTitle: 'Program Specific Survey',
				displayOrder: 2,
				itemTitle: 'Programs',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'SurveyType',
				model: new SurveyType(),
				type: 'ParentPointer',
				using: 'surveyTypeId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'SurveyType',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'surveyId',
				placeholder: null,
				key: 'surveyId',
				isPrimaryKey: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.surveyId,
				setter: (x, y) => x.surveyId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Survey Type',
				placeholder: null,
				key: 'surveyTypeId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 2,
				getter: (x) => x.surveyTypeId,
				setter: (x, y) => x.surveyTypeId = y,
				defaultValue: null,
				editor: 'SurveyTypeFieldEditor',
				viewer: 'SurveyTypeFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Conservation Action Type',
				placeholder: null,
				key: 'conservationActionTypeId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 3,
				getter: (x) => x.conservationActionTypeId,
				setter: (x, y) => x.conservationActionTypeId = y,
				defaultValue: null,
				editor: 'ConservationActionTypeFieldEditor',
				viewer: 'ConservationActionTypeFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Organization',
				placeholder: null,
				key: 'organizationId',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: ["skips_data_segmentation","authenticated_user"]
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: 'When set, this Survey is only visible to the specified Organization and it will override a default Survey for the same (Survey Type + Conservation Action Type) pair. If empty, this Survey will be a default for all Organizations.',
				requiresPermission: ["skips_data_segmentation","authenticated_user"],
				group: 'Program Specific Survey',
				groupTitle: 'Program Specific Survey',
				displayOrder: 1,
				getter: (x) => x.organizationId,
				setter: (x, y) => x.organizationId = y,
				defaultValue: null,
				editor: 'OrganizationFieldEditor',
				viewer: 'OrganizationFieldViewer',
				validators: [
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Info Title',
				placeholder: null,
				key: 'infoTitle',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: 'If set, an information icon will be displayed with this text.',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 5,
				getter: (x) => x.infoTitle,
				setter: (x, y) => x.infoTitle = y,
				defaultValue: '',
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Info Link',
				placeholder: null,
				key: 'infoLink',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: 'If set, the information icon will be a hyperlink to this URL.',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 6,
				getter: (x) => x.infoLink,
				setter: (x, y) => x.infoLink = y,
				defaultValue: '',
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'created',
				placeholder: null,
				key: 'created',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.created,
				setter: (x, y) => x.created = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'modified',
				placeholder: null,
				key: 'modified',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.modified,
				setter: (x, y) => x.modified = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deleted',
				placeholder: null,
				key: 'deleted',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deleted,
				setter: (x, y) => x.deleted = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Published',
				placeholder: null,
				key: 'published',
				isPrimaryKey: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 1,
				getter: (x) => x.published,
				setter: (x, y) => x.published = y,
				defaultValue: null,
				editor: 'BooleanEditor',
				viewer: 'BooleanViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class Survey extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [
			new validators.SurveyValidator(),
		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
